import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Helmet } from 'react-helmet-async';
import { Panel, PanelGroup, Placeholder } from 'rsuite';
import { useAuth } from '../../AuthContext';
import FolderIcon from '@rsuite/icons/Folder';
import { BsCalendar2MonthFill } from 'react-icons/bs';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loader } from 'rsuite';

function HelpPage() {
  const { auth } = useAuth();


  return (
    <>
        <Helmet>
          <title>{`Hjälp`}</title>
        </Helmet>
        <div className='px-5 pt-4 w-100'>
        <h4 className="mb-2">Hur gör jag?</h4>
        <p className="text-muted mb-1">Här finns enklare beskrivningar för att visa hur du använder systemet.</p>
        <hr />
        <div className='bg-white p-3 rounded mb-2'>
          <h3>Hur fungerar delsidan ordrar?</h3>
          <PanelGroup accordion defaultActiveKey={1}>
            <Panel header="Nya / Hanterade ordrar" eventKey={1}>
              <p>I vyn över ordrar kan du växla mellan nya eller hanterade ordrar. En ny order är en order som inte har fått en fraktsedel genererad. En hanterad ordrar har en genererad fraktsedel samt finns i en faktura.</p>
            </Panel>
            <Panel header="Skapa faktura" eventKey={2}>
              <p>Du kan skapa en faktura genom att klicka på den orangea knappen. Detta skapar en faktura som hittas under delsidan "Fakturor"  i sidomenyn. Fakturor inkluderar bara ordrar som är hanterade, och som inte redan finns i en faktura. Detta sköts automatiskt.</p>
            </Panel>
            <Panel header="Specifik order" eventKey={3}>
              <p>Om du klickar på en order kan du se orderns innehåll. Här kan du skapa en fraktsedel, ladda ner en fraktsedel eller skapa en kreditfaktura. Ibland läser systemet inte av ordern 100% korrekt, då dyker det upp en varningsruta. Om du klickar på varningsrutan kan du uppdatera beställarens uppgifter baserat på råa innehållet i form av text under input rutorna.</p>
              <p>Om uppgifterna inte stämmer, kommer du inte kunna generera en fraktsedel.</p>
            </Panel>
          </PanelGroup>
        </div>

        <div className='bg-white p-3 rounded mb-2'>
          <h3>Hur fungerar delsidan fakturor?</h3>
          <PanelGroup accordion defaultActiveKey={1}>
            <Panel header="Fakturor" eventKey={1}>
              <p>Här kan du se alla genererade fakturor samt kreditfakturor. Du kan ladda ner fakturor i form av PDFer, och markera dem som betalade. Markera bara en faktura som betalad om Delticom har betalat fakturan, annars kan det uppstå missförstånd i bokföring.</p>
            </Panel>
          </PanelGroup>
        </div>

        <div className='bg-white p-3 rounded mb-2'>
          <h3>Hur fungerar delsidan Prisfilter?</h3>
          <PanelGroup accordion defaultActiveKey={1}>
            <Panel header="Hur sätts priser" eventKey={1}>
              <p>Påslag sätts på produkter som laddas upp till Shopify samt till Delticom. Priser sätts baserat på tumstorlek och leverantör. Påslag för shopify heter "Påslag". Påslag för Delticom heter "Delticom påslag (Ex moms)". Påslag åt Delticom är alltså ex. moms.</p>
            </Panel>
            <Panel header="När uppdateras priset?" eventKey={2}>
              <p>Priset uppdateras nästa gång systemet uppdaterar alla produkter.</p>
            </Panel>
            <Panel header="Kan jag skapa dubletter?" eventKey={3}>
              <p>Nej, om du försöker skapa en prisregel som redan finns kommer systemet att ge avslag.</p>
            </Panel>
            <Panel header="Kan jag ta bort en prisregel?" eventKey={3}>
              <p>Nej, för att produkter inte ska visas som nettopris är det inte möjligt att ta bort en prisregel. Du kan enbart uppdatera en prisregel, alternativt skapa en prisregel som inte finns.</p>
            </Panel>
          </PanelGroup>
        </div>

        </div>
    </>
  );
}

export default HelpPage;
